import { render, staticRenderFns } from "./ChangesHeader.vue?vue&type=template&id=63cc3ead&scoped=true&lang=pug&"
import script from "./ChangesHeader.vue?vue&type=script&lang=js&"
export * from "./ChangesHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChangesHeader.vue?vue&type=style&index=0&id=63cc3ead&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc3ead",
  null
  
)

export default component.exports